import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { Poptional, Subpoptional } from '../../models/poptional';
import { PoptionalSelection } from '../../models/poptional-selection';
import { faMinus, faPlus, faCheck } from '../../../icons';
@Component({
    selector: 'app-poptionals',
    templateUrl: './poptionals.component.html',
    styleUrls: ['./poptionals.component.scss'],
    standalone: false
})
export class PoptionalsComponent implements OnInit {
  faPlus = faPlus;
  faMinus = faMinus;
  faCheck = faCheck;
  @Input() poptionals: Poptional[];
  @Input() itemQty: number;
  @Output() onDone: EventEmitter<PoptionalSelection[]> = new EventEmitter();
  @Output() onCancel: EventEmitter<any> = new EventEmitter();

  idx: number = 0;
  current: Poptional;

  selections: PoptionalSelection[] = [];
  curSelection: PoptionalSelection;

  constructor() { }

  ngOnInit(): void {
    for(let popt of this.poptionals) {
      this.selections.push(PoptionalSelection.createDefault(popt, this.itemQty || 1));
    }
    this.setCurrent(0);
  }

  setCurrent(index: number) {
    this.idx = index;
    this.current = this.poptionals[index];
    this.curSelection = this.selections[index];
  }

  toggleCheckbox(idxSub: number|null) {
    if(!this.curSelection.canToggle(idxSub)) {
      return;
    }
    if(idxSub != null) {
      if(this.curSelection.subpoptionals[idxSub].qty == 1) {
        this.curSelection.lessQty(idxSub);
      } else {
        this.curSelection.moreQty(idxSub);
      }
    } else {
      if(this.curSelection.qty == 1) {
        this.curSelection.lessQty();
      } else {
        this.curSelection.moreQty();
      }
    }
    if(this.curSelection.minReached && this.curSelection.maxReached) {
      setTimeout(() => {
        this.proceed();
      }, 350);
    }
  }

  goBack() {
    if(this.idx <= 0){
      this.cancel();
    } else {
      this.setCurrent(this.idx - 1);
    }
  }
  proceed() {
    if(this.idx == this.poptionals.length - 1) {
      this.done();
    } else {
      this.setCurrent(this.idx + 1);
    }
  }

  lastStep(): boolean {
    return this.idx == this.poptionals.length - 1;
  }

  done() {
    this.onDone.emit(this.selections);
  }
  cancel() {
    this.onCancel.emit();
  }
}
